import React, { useEffect, useState } from 'react';
import { Box } from '@chakra-ui/react';
import PatientsTable from './components/PatientsTable';
import { createAPIEndPoint } from 'config/api/api';
import toast from 'react-hot-toast';
import Loader from 'loaders/Loader';
import { logoutUser } from 'utils';
import { useNavigate } from 'react-router-dom';
import { getUserData } from 'utils';
import useDebounce from 'hooks/useDebounce';

const Patients = () => {
  const userData = getUserData();
  const clinic_id = userData?.clinic_id ?? null;
  const navigate = useNavigate();
  const [patientsData, setPatientsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearch = useDebounce(searchTerm, 1000);

  // const fetchPatients = async (page = 1, limit = 10, query = '') => {
  //   if (!clinic_id) return;
  //   setLoading(true);
  //   try {
  //     const queryParam = query ? `&query=${encodeURIComponent(query)}` : '';
  //     const url = `patient/get_all_pagination_data/${clinic_id}?page=${page}&page_size=${limit}${queryParam}`;

  //     const { data } = await createAPIEndPoint(url).fetchAll();
  //     console.log(' fetchPatients ~ data:', data);
  //     const { patients = [], pages = 0 } = data || {};
  //     console.log(' fetchPatients ~ patients:', patients);

  //     setPatientsData(patients);
  //     setTotalPages(pages);
  //     setLoading(false);
  //   } catch (err) {
  //     setLoading(false);
  //     setPatientsData([]);
  //     setTotalPages(0);
  //     toast.error(err?.response?.data?.error || 'Error fetching patient');
  //     if (err?.response?.data?.error?.includes('Bearer token')) {
  //       logoutUser(navigate);
  //     }
  //   }
  // };

  const fetchPatients = async (page = 1, limit = 10, query = '') => {
    if (!clinic_id) return;
    setLoading(true);
    try {
      const queryParam = query ? `&query=${encodeURIComponent(query)}` : '';
      const url = `patient/get_all_pagination_data/${clinic_id}?page=${page}&page_size=${limit}${queryParam}`;

      const response = await createAPIEndPoint(url).fetchAll();
      console.log(' fetchPatients ~ data:', response);

      // adjust based on actual API structure
      const data = response?.data || response;

      setPatientsData(data?.patients || []);
      setTotalPages(data?.pages || 0);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setPatientsData([]);
      setTotalPages(0);
      toast.error(err?.response?.data?.error || 'Error fetching patient');
      if (err?.response?.data?.error?.includes('Bearer token')) {
        logoutUser(navigate);
      }
    }
  };

  useEffect(() => {
    fetchPatients(currentPage, itemsPerPage, debouncedSearch);
  }, [clinic_id, currentPage, itemsPerPage, debouncedSearch]);

  // const fetchPatients = async () => {
  //   setLoading(true);
  //   try {
  //     const response = await createAPIEndPoint(
  //       `patient/get_all/${clinic_id}`,
  //     ).fetchAll();
  //     setLoading(false);
  //     setPatientsData(response.data || []);
  //   } catch (err) {
  //     toast.error(err?.response?.data?.error || 'Error fetching patient');
  //     if (err?.response?.data?.error?.includes('Bearer token')) {
  //       logoutUser(navigate);
  //     }
  //   }
  // };

  // useEffect(() => {
  //   fetchPatients();
  // }, []);

  return (
    <Box pt={{ base: '80px', md: '80px', xl: '80px' }}>
      {loading && <Loader />}
      <PatientsTable
        tableData={patientsData}
        loading={loading}
        fetchAgain={() => fetchPatients(currentPage, itemsPerPage)}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
        totalPages={totalPages}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
      {/* <PatientsTable
        tableData={patientsData}
        loading={loading}
        fetchAgain={fetchPatients}
      />{' '} */}
    </Box>
  );
};

export default Patients;
